// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typePickemPoolGetBody = {
  poolId: string;
};

export type typePickemPoolGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    contest: {
      contestId: string;
      seasonId: string;
      name: string;
      status: "upcoming" | "active" | "pendingOutcome" | "confirmed";
      startDate: string;
      endDate: string;
      endDateMode: "date" | "tbd";
    } | null;
    settings: {
      scoringFormat: "standard" | "confidence";
      picksRequiredMode: "all" | "count";
      picksRequiredCount?: number | null;
      pickBasis: "moneyline" | "spread";
      tiebreaker: "none" | "totalPoints";
      tiePolicy: "tieIsWin" | "tieIsLoss" | "tieIsVoid";
      winPoints: number;
      lossPoints: number;
      roundGrouping: "day" | "week";
      weekStartDay?: number | null;
      startDate?: string | null;
      endDate?: string | null;
      endDateMode: "date" | "tbd";
      frozenFields: string[];
      pendingChangeFromRoundLabel?: string | null;
    } | null;
    rulesLines: string[];
    rounds: {
      roundId: string;
      label: string;
      ordinal: number;
      status: "scheduled" | "open" | "locked" | "graded";
      startDate: string;
      endDate: string;
      firstLockAt?: string | null;
      lastLockAt?: string | null;
      gameCount: number;
      myPicksMade: number;
      myPicksRequired: number;
      myPoints?: number | null;
      isCurrent: boolean;
    }[];
    currentRoundId: string | null;
    viewer: {
      userId: string;
      entryId?: string | null;
      isAdmin: boolean;
      canEditSettings: boolean;
      picksStillNeeded: number;
      nextLockAt?: string | null;
    };
    emptyState: "none" | "noContest" | "noRoundsYet" | "contestEnded";
  };
};

export type typePickemPoolGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePickemPoolGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePickemPoolGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaPickemPoolGetBody = {
  type: "object",
  properties: { poolId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["poolId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createPickemPoolGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaPickemPoolGetBody);
  }

  return async function postPickemPoolGet(
    payload: typePickemPoolGetBody,
  ): Promise<typePickemPoolGetOutput200 | typePickemPoolGetOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postPickemPoolGet" failed before calling the network. #7684dfbba434`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#7684dfbba434" },
        },
        data: null,
      } as typePickemPoolGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/pickem/pool-get`,
      httpMethod: "POST",
      options,
    })) as typePickemPoolGetOutput200 | typePickemPoolGetOutput400;
  };
}
